import React from 'react';
import FakeRecaptchaInstance from '../recaptcha/fake_recaptcha_instance';

// We pass a fake recaptcha instance by default because this is what
// our unit tests will have to use. In every other case, the defaultValue
// of the context should not be used.
const RecaptchaContext = React.createContext(new FakeRecaptchaInstance());

export default RecaptchaContext;
